module.exports = __webpack_public_path__ + "media/images/emblems/Cressier-FR-coat_of_arms-9f108a96ab09f2afc37a3e9d68805ef0.svg";